import styled from 'styled-components';
import Heading from 'elements/typography/heading';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';

export const StoriesOfAwesomeSection = styled.div`
  max-width: 100% !important;
  background-color: ${palette.blackSqueeze}
`

export const StoriesOfAwesomeContainer = styled.div`
  padding: 2.5em 0;
  max-width: 1440px;
  margin: 0 auto;

  @media screen and (min-width: ${layout.subLg}) {
    padding: 5em 0;
  }
`

export const CoursesStoriesHeadingContainer = styled.div`
  max-width: 640px;
  margin: 0 auto 2.5em;

  & > h1 {
    margin-bottom: 1rem;
  }

  @media screen and (max-width: ${layout.subLg}) {
    margin: 0 auto 2em;
    max-width: 100%;
    padding: 0 1.5rem;
  }
`

export const StoryItem = styled.div`
  position: relative;
  box-sizing: border-box;
  min-height: 500px;

  @media screen and (min-width: ${layout.subLg}) {
    padding: 0 20px;
  }
`

export const StoryImageContainer = styled.div`
  position: relative;
`

export const StoryImage = styled(GatsbyImage) <GatsbyImageProps>`
  height: 500px;
`

export const StoryImageOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(180.08deg, rgba(25, 31, 40, 0) 36.68%, #000 73.46%);
  opacity: .6;
  z-index: 1;
`

export const StoryTitle = styled(Heading)`
  color: ${palette.white} !important;
  margin: 1em auto;
`

export const StoryInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 2em;
  z-index: 2;
`

export const StoriesSliderContainer = styled.div`
  max-width: 1260px;
  margin: 0 auto;
`
